module.exports = __webpack_public_path__ + "media/src/components/shared/general/rating_img/greyStar-e32318b821df31bed727d69d087c5a70.png";